/** RFC 4180-style parsing for the import mapping preview, including quoted line breaks. */
export function parseCsvRows(input: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [],
    cell = '',
    quoted = false;
  const text = input.replace(/^\uFEFF/, '');
  for (let index = 0; index < text.length; index++) {
    const char = text[index];
    if (char === '"') {
      if (quoted && text[index + 1] === '"') {
        cell += '"';
        index++;
      } else quoted = !quoted;
    } else if (char === ',' && !quoted) {
      row.push(cell);
      cell = '';
    } else if ((char === '\n' || char === '\r') && !quoted) {
      if (char === '\r' && text[index + 1] === '\n') index++;
      row.push(cell);
      if (row.some((value) => value.trim())) rows.push(row);
      row = [];
      cell = '';
    } else cell += char;
  }
  if (quoted)
    throw new Error('A CSV value has an unclosed quote. Check the file before importing.');
  row.push(cell);
  if (row.some((value) => value.trim())) rows.push(row);
  return rows;
}
export function mapCsvColumns(input: string, mapping: Record<string, string>): string {
  const [headers, ...rows] = parseCsvRows(input);
  if (!headers?.length || !mapping.name)
    throw new Error('Map the full name column before previewing.');
  if (new Set(headers.map((header) => header.trim().toLowerCase())).size !== headers.length)
    throw new Error('CSV column names must be unique before mapping.');
  if (rows.some((row) => row.length > headers.length))
    throw new Error(
      'A CSV row has more values than the header. Check separators and quoted values.',
    );
  if (!mapping.email && !mapping.phone)
    throw new Error('Map an email or phone column for identity verification.');
  const fields = Object.keys(mapping).filter((key) => mapping[key]);
  const indices = fields.map((key) => headers.indexOf(mapping[key]));
  if (indices.some((index) => index < 0))
    throw new Error('A mapped column is no longer in the file. Check column mapping.');
  if (new Set(indices).size !== indices.length)
    throw new Error('Each source column can map to one CRM field only.');
  const escape = (value: string) => `"${value.replaceAll('"', '""')}"`;
  return [fields, ...rows.map((row) => indices.map((index) => row[index] || ''))]
    .map((row) => row.map(escape).join(','))
    .join('\r\n');
}
